<div class="processing-dialog" fxLayout="column" fxLayoutGap="3px">
  <span>{{label | translate}}</span>
  <mat-progress-bar [mode]="mode" [color]="color"></mat-progress-bar>
</div>
